import Link from 'next/link'
import { LuChevronRight } from 'react-icons/lu'

import { cn } from '@/core/utils/common'
import { CARD_FX } from '@/features/veluvit/components/ui/card-fx'
import MediaImage from '@/features/veluvit/components/ui/media-image'
import { to } from '@/features/veluvit/lib/route'

import type { Announcement } from '@/features/veluvit/hooks/use-announcement'

export default function AnnouncementBanner({
  announcement,
}: {
  announcement?: Announcement
}) {
  if (!announcement?.enabled || !announcement.title) return null
  const notice = (
    <>
      {announcement.imageUrl && (
        <MediaImage
          src={announcement.imageUrl}
          alt=""
          width={1600}
          height={480}
          unoptimized
          appearance="plain"
          className="h-auto max-h-80 w-full object-contain"
          containerClassName="block! w-full"
        />
      )}
      <div className="flex items-center gap-3 px-3.5 py-3">
        <div className="min-w-0 flex-1">
          <p className="mb-0.5 text-c12 text-t3">
            {announcement.severity === 'incident'
              ? '장애 안내'
              : announcement.severity === 'maintenance'
                ? '점검 안내'
                : '공지사항'}
          </p>
          <h2 className="text-c14 font-semibold text-t1">
            {announcement.title}
          </h2>
          {announcement.text && (
            <p className="mt-1 whitespace-pre-line text-c13 text-t2">
              {announcement.text}
            </p>
          )}
        </div>
        {announcement.linkUrl && (
          <LuChevronRight
            aria-hidden="true"
            className="size-4.5 flex-none text-t3"
          />
        )}
      </div>
    </>
  )
  const className = cn(
    'block overflow-hidden rounded-panel bg-well text-left no-underline',
    CARD_FX
  )
  return (
    <section
      aria-label="공지사항"
      className="px-4 pt-3 over10:px-8 over10:pt-6"
    >
      {announcement.linkUrl ? (
        <Link
          href={to(announcement.linkUrl)}
          className={cn(className, 'transition-colors hover:bg-hover')}
        >
          {notice}
        </Link>
      ) : (
        <div className={className}>{notice}</div>
      )}
    </section>
  )
}
